export default class PCHeader {
  constructor() {
    this.triggers = document.querySelectorAll('.js-header-trigger');
    this.contents = document.querySelectorAll('.js-header-content'); 
    this.activeClass = 'is-active';
    this.currentClass = 'is-current';
    this.timeoutId = null;

    this.init();
  }

  init() {
    this.triggers.forEach(trigger => {
      const menuName = trigger.dataset.menu;
      const content = document.querySelector(`.js-header-content[data-menu="${menuName}"]`);
      if (!content) return;

      // トリガーにマウスが乗ったら
      trigger.addEventListener('mouseenter', () => {
        clearTimeout(this.timeoutId);
        // 他を閉じる
        this.closeAllContents(); 
        this.openContent(content,trigger);
      });

      // トリガーから出たら閉じ処理予約
      trigger.addEventListener('mouseleave', () => {
        this.timeoutId = setTimeout(() => {
          this.closeAllContents();
        }, 200);
      });

      // コンテンツ上に乗ったら閉じない
      content.addEventListener('mouseenter', () => {
        clearTimeout(this.timeoutId);
      });

      // コンテンツからも離れたら閉じる
      content.addEventListener('mouseleave', () => {
        this.timeoutId = setTimeout(() => {
          this.closeAllContents();
        }, 200);
      });
    });

    this.currentMenu();
  }

  openContent(content,trigger) {
    trigger.classList.add(this.activeClass);
    content.classList.add(this.activeClass);
    content.style.maxHeight = `${content.scrollHeight}px`;
  }

  closeAllContents() {
    this.triggers.forEach(trigger => {
      trigger.classList.remove(this.activeClass);
    });
    this.contents.forEach(content => {
      content.classList.remove(this.activeClass);
      content.style.maxHeight = '0';
    });
  }

  currentMenu() {
  const path = location.pathname; // 例: /cmt/cm/ → ['cmt', 'cm']
  const pathParts = path.split('/').filter(Boolean);

  if (pathParts.length === 0) return;

  // 2階層目で一致するトリガーを探す 
  for (let i = pathParts.length; i > 0; i--) {
    const candidate = pathParts.slice(1, i).join('/'); // 例: "cmt/cm" → "cm"
    const trigger = document.querySelector(`.js-header-current[data-menu="${candidate}"]`);
    if (trigger) {
      trigger.classList.add(this.currentClass);
      break;
    }
  }
}
}
